import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ChurchIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 12.3227V9.82519L13.5 6.70151V4.5L13 3L12 0L11 3L10.5 4.5V6.70151L5 9.82519V12.3227L0 14.3232V24H24V14.3232L19 12.3227ZM2 15.6768V22L5 22V14.4772L2 15.6768ZM13 18V22H17V10.9893L12 8.15039L7 10.9893V22H11V18H13ZM19 22H22V15.6768L19 14.4772V22Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15C12.8284 15 13.5 14.3284 13.5 13.5C13.5 12.6716 12.8284 12 12 12C11.1716 12 10.5 12.6716 10.5 13.5C10.5 14.3284 11.1716 15 12 15Z",
    fill: "currentColor"
  }));
}